import axios from "axios";
import { useState } from "react";
import { Modal, Form, Button, Container, Row, Col } from "react-bootstrap";

import { useAuth } from "hooks/useAuth";
import { getISOCurrentDate } from "utils/timeUtils";

export default function ValidatorCheckoutApprovalModal({
  show,
  handleClose,
  product,
  currentPP,
  refetch,
  setAlert,
}) {
  const [checkoutPackageInfo, setCheckoutPackageInfo] = useState({});
  const [file, setFile] = useState({});
  const [fileName, setFileName] = useState("");

  const { authToken, csrfToken } = useAuth();

  const handleChange = (e) => {
    if (e.target.name === "file") {
      setFile({ ...file, [e.target.name]: e.target.files[0] });
      setFileName(
        "CCEVS-VR-VID" +
          product.v_id.toString() +
          "-" +
          new Date().getFullYear().toString(),
      );
    } else {
      setCheckoutPackageInfo({
        ...checkoutPackageInfo,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleUpdateEvaluatorCheckoutFiles = () => {
    axios
      .put(
        `${import.meta.env.VITE_DJANGO_ENDPOINT}file/update_evaluator_checkout_files/`,
        { pid: product.product_id },
        {
          withCredentials: true,
          headers: {
            Authorization: `Token ${authToken}`,
            "X-CSRFToken": csrfToken,
          },
        },
      )
      .then(() => {
        console.log("files updated");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    //adding validator checkout out and posting to file endpoint
    const submittedData = new FormData();
    submittedData.append("active", JSON.stringify(true));
    submittedData.append("file", file.file);
    submittedData.append("file_type_id", product?.product_id);
    submittedData.append("file_type", "product");
    submittedData.append("file_source_type", "Validator Check Out");
    submittedData.append("file_display_name", "Final Draft Validation Report");
    submittedData.append("uploaded_on", getISOCurrentDate());
    submittedData.append("private", JSON.stringify(false));
    submittedData.append("file_name", fileName);
    submittedData.append("file_label", fileName);

    axios
      .post(`${import.meta.env.VITE_DJANGO_ENDPOINT}file/`, submittedData, {
        withCredentials: true,
        headers: {
          "X-CSRFToken": csrfToken,
          Authorization: `Token ${authToken}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then(() => {
        let resubmissionCounter = currentPP.resubmission_counter;
        if (resubmissionCounter === null) {
          resubmissionCounter = 0;
        } else {
          resubmissionCounter += 1;
        }
        handleUpdateEvaluatorCheckoutFiles();
        axios
          .put(
            `${import.meta.env.VITE_DJANGO_ENDPOINT}project/progress/update_progress/`,
            {
              product: product.product_id,
              progress_point: 7,
              status: "Ready for Release",
            },
            {
              withCredentials: true,
              headers: {
                "X-CSRFToken": csrfToken,
                Authorization: `Token ${authToken}`,
              },
            },
          )
          .then(() => {
            axios
              .put(
                `${import.meta.env.VITE_DJANGO_ENDPOINT}project/progress/update_progress/`,
                {
                  product: product.product_id,
                  progress_point: 6,
                  status: "Completed",
                },
                {
                  withCredentials: true,
                  headers: {
                    "X-CSRFToken": csrfToken,
                    Authorization: `Token ${authToken}`,
                  },
                },
              )
              .then(() => {
                refetch();
                handleClose();
                setAlert({
                  variant: "success",
                  message: "Progress Point Successfully Approved",
                });
              })
              .catch((error) => console.log(error));
          })
          .catch((error) => {
            console.log("error updating progress point", error);
          });
      })
      .catch((error) => {
        console.log("error updating product", error);
      });
  };

  return (
    <Modal size="lg" show={show} onHide={handleClose}>
      <Form onSubmit={handleSubmit} id="validator-checkout-approval-form">
        <Modal.Header className="border-0" closeButton>
          <Modal.Title>
            <h3 className="text-bright-navy m-0">CHECK OUT PACKAGE</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container className="mt-5">
            <Row>
              <Col sm={3} className="mt-auto">
                <h5>Validation Report: </h5>
              </Col>
              <Col sm={9}>
                <Form.Group controlId="file">
                  <Form.Label className="small text-secondary">
                    Attach File
                  </Form.Label>
                  <Form.Control
                    type="file"
                    name="file"
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              {Object.keys(file).length > 0 && (
                <Row className="d-flex justify-content-center mt-4">
                  <Col xs={5} lg={3} className="border-bottom">
                    <p className="m-0 p-2">Validation Report</p>
                  </Col>
                  <Col xs={5} lg={5} className="border-bottom">
                    <p className="m-0 p-2">{fileName}</p>
                  </Col>
                  <Col xs={2} lg={1} className="m-0 p-2 border-bottom">
                    <Button
                      variant="outline-primary"
                      className="attachment-remove"
                      onClick={() => setFile({})}
                    >
                      X
                    </Button>
                  </Col>
                </Row>
              )}
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="primary"
            className="rounded-pill"
            type="submit"
            disabled={Object.keys(file).length === 0}
          >
            Save/Submit
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
